export default "__VITE_ASSET__$BiYWM7A__"